import { render } from "./ServiceProperty.vue?vue&type=template&id=65b1763b&scoped=true"
import script from "./ServiceProperty.vue?vue&type=script&lang=js"
export * from "./ServiceProperty.vue?vue&type=script&lang=js"

import "./ServiceProperty.vue?vue&type=style&index=0&id=65b1763b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b1763b"]])

export default __exports__